import { useAccordionContext, useAccordionItemState } from "@chakra-ui/react";
import { ContentExpandButton } from "shared/components/button/ContentExpandButton";

export const AccordionIcon: React.FC = () => {
  const { isOpen, isDisabled } = useAccordionItemState();
  const { reduceMotion } = useAccordionContext();
  return (
    <ContentExpandButton
      isExpanded={isOpen}
      isDisabled={isDisabled}
      reduceMotion={reduceMotion}
    />
  );
};
